import React, { Component } from "react";
import { LinkContainer } from "react-router-bootstrap";
import LoaderButton from "../components/LoaderButton";
import "./Settings.css";
import { Auth } from "aws-amplify";


export default class Settings extends Component {
  constructor(props) {
    super(props);

    this.state = {
      uid:"",
      email:"",
    };

    console.log(Auth.currentCredentials())
    this.userinfo()
  }


  async userinfo(){

 const user = await Auth.currentCredentials();
 // /console.log(user)
 const userinfo = await Auth.currentUserInfo();
 console.log(userinfo)
this.setState({email:userinfo.attributes.email})
this.setState({uid:user._identityId})


  }

  render() {
    return (
      <div className="Settings">
        <LinkContainer to="/settings/email">
          <LoaderButton
            block
            bsSize="large"
            text="Change Email"
          />
        </LinkContainer>
        <LinkContainer to="/settings/password">
          <LoaderButton
            block
            bsSize="large"
            text="Change Password"
          />
        </LinkContainer>

        <br></br>
        <i>unique identity<p>{this.state.uid}</p></i><br/>
        <i>Email<p>{this.state.email}</p></i>


      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Settings.js